import { useState } from 'react';
import { Shield, Loader2 } from 'lucide-react';
import api from '@/utils/api';

export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const { data } = await api.post('/auth/login', { username, password });
      localStorage.setItem('admin_token', data.token);
      onLogin(data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid credentials');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-cwc-navy flex items-center justify-center px-4">
      <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 w-full max-w-md shadow-2xl" data-testid="admin-login-form">
        <div className="flex items-center justify-center gap-2 mb-6">
          <Shield className="w-8 h-8 text-cwc-gold" />
          <h1 className="text-2xl font-bold text-cwc-navy">Admin Login</h1>
        </div>
        {error && <p className="text-red-600 text-sm mb-4 bg-red-50 p-3 rounded-lg" data-testid="admin-login-error">{error}</p>}
        <input type="text" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm mb-3 focus:ring-2 focus:ring-cwc-gold/50 outline-none" required data-testid="admin-login-username" />
        <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm mb-4 focus:ring-2 focus:ring-cwc-gold/50 outline-none" required data-testid="admin-login-password" />
        <button type="submit" disabled={loading} className="w-full bg-cwc-navy text-white font-semibold py-3 rounded-lg hover:bg-cwc-navy/90 transition-colors flex items-center justify-center gap-2" data-testid="admin-login-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Sign In'}
        </button>
      </form>
    </div>
  );
}
